import { defineStore } from 'pinia'
import { ref } from "vue";
import { request } from "@/ts/request";
import { RequestStatus } from "@/ts/interfaces/requests/statusEnum";
import { projectBasePathName, projectEditPath } from "@/ts/apiRoutes";

export const useProjectEditStore = defineStore('project-edit',  () => {
    const status = ref<RequestStatus | null >(RequestStatus.INITIAL)

    async function edit(id: number, data: object) {
        const response = await request(`${projectBasePathName}/${id}${projectEditPath}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Content-type': 'application/json; charset=UTF-8'
            },
        })

        if(response.ok) {
            status.value = RequestStatus.SUCCESS
        }

        return response
    }

    return { status, edit }
})